import { GridProps } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { useRef } from 'react';
import { ListingProps } from '@/types/listing';
import ContentSection, {
  SectionHeading,
} from '@/components/frontend/ContentSection';
import ListingDetailsBlock from './Block';

const ListingDetailsSection = ({
  listing,
  ...gridStyles
}: Pick<ListingProps, 'listing'> & GridProps) => {
  const { t } = useTranslation('frontoffice');
  const sectionRef = useRef<HTMLDivElement>(null);

  return (
    <ContentSection {...gridStyles} ref={sectionRef}>
      <SectionHeading>{t('extra_information', 'Lisätiedot')}</SectionHeading>
      <ListingDetailsBlock listing={listing} sectionRef={sectionRef} />
    </ContentSection>
  );
};

export default ListingDetailsSection;
